import React, { ComponentProps, FC, Fragment, useCallback, useContext } from 'react';
import { Card, Divider } from '@sravni/react-design-system';
import { StepContext } from '../../../creator/step.context';
import cn from 'classnames';
import { FormStepWrapper as FormStep } from './form.step';
import styles from './styles.module.scss';

type Props = ComponentProps<'div'>;
export const Form: FC<Props> = (props) => {
    const { className } = props;
    const { currentStep, setStep, stepsConfig: steps, focusedField } = useContext(StepContext);

    const onEditClick = useCallback(
        (index: number) => {
            setStep(index);
        },
        [setStep],
    );

    return (
        <>
            <Card
                className={cn(
                    styles['form-accordion'],
                    { [styles['form-accordion_hidden']]: !!focusedField },
                    className,
                )}>
                {steps.map((step, index) => (
                    <Fragment key={step.stepName}>
                        <FormStep step={step} stepIndex={index} currentStep={currentStep} onEditClick={onEditClick} />
                        {index < steps.length - 1 && <Divider />}
                    </Fragment>
                ))}
            </Card>
            <div id="stickySubmitContainer" className={styles['sticky-submit-container']} />
        </>
    );
};
